import type { ReactElement } from 'react';
import classNames from 'classnames';

import { IconButton } from '@common/IconButton/IconButton';
import { IconColor, IconID } from '@common/Icon/Icon';

interface NumberInputControlButtonsProps {
  children: ReactElement;
  onChange: (value: number) => void;
  value?: number;
}

export const NumberInputControlButtons = ({ children, onChange, value }: NumberInputControlButtonsProps) => {
  const numberValue = Number(value);
  const isMinusButtonDisabled = numberValue <= 1;

  return (
    <div className="flex items-stretch">
      <IconButton
        className={classNames(
          'flex items-center h-full leading-none px-4',
          isMinusButtonDisabled ? 'hover:bg-gray-200 bg-gray-200 pointer-events-none cursor-default' : 'bg-gray-500'
        )}
        size={4}
        icon={IconID.MINUS}
        iconColor={IconColor.WHITE}
        disabled={isMinusButtonDisabled}
        onClick={() => onChange(numberValue - 1)}
      />

      {children}

      <IconButton
        className="flex items-center h-full bg-gray-500 leading-none px-4"
        size={4}
        icon={IconID.PLUS}
        iconColor={IconColor.WHITE}
        onClick={() => onChange(numberValue + 1)}
      />
    </div>
  );
};
